document.addEventListener("DOMContentLoaded", function () {
  const searchModalContainer = document.querySelector(".predictive-search");

  if (searchModalContainer) {
    const observer = new MutationObserver(() => {
      applyProductSwatches();
    });

    observer.observe(searchModalContainer, { childList: true });
  }

  applyProductSwatches();
});

const createHomeShadeLoader = () => {
  let loaderOverlay = document.querySelector(".home-shade-loader-overlay");
  if (!loaderOverlay) {
    loaderOverlay = document.createElement("div");
    loaderOverlay.className = "home-shade-loader-overlay";
    loaderOverlay.innerHTML = `
       <span class="loader"></span>
    `;
    document.body.appendChild(loaderOverlay);
  }
  return loaderOverlay;
};
 

const applyProductSwatches = () => {
  const featured_cards = document.querySelectorAll(".featured-card-product");

  featured_cards.forEach((featured_card) => {
    const productData = featured_card.querySelector("[data-selected-variant-meta]")?.innerHTML;
    const swatches = featured_card.querySelectorAll(".product-swatch");

    const parsedProductData = productData ? JSON.parse(productData) : {};
    const default_selected_variant = parsedProductData.default_selected_variant;

    const withWidth = (url, w) => (url.includes("?") ? `${url}&width=${w}` : `${url}?width=${w}`);
    const isLoyaltyLogin = (root) => Boolean(root?.querySelector?.("[data-loyalty-login='true']"));

    const UpdateProductImage = (updated_image, secondary_updated_image) => {
      if (!updated_image) return;

      // ---- PRIMARY ----
      const primary_image = featured_card.querySelector(".primary_image");
      if (!primary_image) return;

      const picture = primary_image.closest("picture");
      if (!picture) return;

      const url1x = withWidth(updated_image, 630);
      const url2x = withWidth(updated_image, 1260);

      const currentSrc = primary_image.src || primary_image.getAttribute("data-src") || "";
      const isImageChanging = !currentSrc.includes(updated_image.split("?")[0]);

      const loaderOverlay = isImageChanging ? createHomeShadeLoader() : null;
 
      const source = picture.querySelector("source");
 
      const CACHE_THRESHOLD = 50;
      const MIN_LOADER_DURATION = 500;
     
      let loaderShown = false;
      let loaderShowTime = null;
     
      const loaderTimeout = loaderOverlay ? setTimeout(() => {
        loaderShown = true;
        loaderShowTime = Date.now();
        loaderOverlay.classList.add("show");
      }, CACHE_THRESHOLD) : null;
 
      const updateImageAndHideLoader = () => {
        if (loaderTimeout) {
          clearTimeout(loaderTimeout);
        }
       
        const applyImageUpdate = () => {
          if (source) {
            source.srcset = `${url1x} 1x, ${url2x} 2x`;
          }
          primary_image.src = url1x;
          if (loaderOverlay) {
            loaderOverlay.classList.remove("show");
          }
        };
       
        if (loaderOverlay && loaderShown) {
          const elapsedTime = Date.now() - loaderShowTime;
          const remainingTime = Math.max(0, MIN_LOADER_DURATION - elapsedTime);
         
          setTimeout(applyImageUpdate, remainingTime);
        } else {
          applyImageUpdate();
        }
      };
 
      const img = new Image();
      img.onload = () => {
        updateImageAndHideLoader();
      };
      img.onerror = () => {
        updateImageAndHideLoader();
      };
      img.src = url1x;

      // ---- SECONDARY ----
      const secondaryImg = featured_card.querySelector(".secondary_image");
      const secondaryPic = secondaryImg?.closest("picture");
      if (!secondaryPic) return;

      if (!secondary_updated_image) {
        secondaryPic.classList.add("hidden");
        return;
      }

      const s1x = withWidth(secondary_updated_image, 630);
      const s2x = withWidth(secondary_updated_image, 1260);

      const swapSecondary = () => {
        const sSrc = secondaryPic.querySelector("source");
        if (sSrc) {
          const ss = `${s1x} 1x, ${s2x} 2x`;
          sSrc.setAttribute("srcset", ss);
          sSrc.setAttribute("data-srcset", ss);
        }
        secondaryImg.setAttribute("src", s1x);
        secondaryImg.setAttribute("data-src", s1x);
        secondaryPic.classList.remove("hidden");
      };

      const preloadSecondary = new Image();
      preloadSecondary.decoding = "async";
      preloadSecondary.src = s1x;
      preloadSecondary.onload = swapSecondary;
      preloadSecondary.onerror = swapSecondary;
    };

    const UpdateProductDescription = (updated_short_description) => {
      const short_description = featured_card.querySelector(".featured-card_product-description");
      if (short_description && updated_short_description) {
        short_description.innerHTML = updated_short_description;
      } else if (short_description) {
        short_description.innerHTML = "<span></span>";
      }
    };

    const UpdateAddToBagStatus = (isAvailable) => {
      const add_to_bag = featured_card.querySelector(".product-form__submit");
      if (add_to_bag) {
        if (isAvailable) {
          add_to_bag.removeAttribute("disabled");
          if (add_to_bag?.hasAttribute("preorder")) {
            add_to_bag.textContent = "Pre-Order";
          }
        } else {
          add_to_bag.setAttribute("disabled", isAvailable);
          if (add_to_bag?.hasAttribute("preorder")) {
            add_to_bag.textContent = "Out Of Stock";
          }
        }
      }
    };

    const updateVariantQuantityLimits = (variant) => {
      if (!variant) return;

      const inventoryQuantity = variant.inventory;
      const maxOrderQuantity = variant.max_product_quantity;
      let maxQuantity = maxOrderQuantity;

      if (inventoryQuantity !== null && (maxOrderQuantity === null || maxOrderQuantity > inventoryQuantity)) {
        maxQuantity = inventoryQuantity;
      }

      featured_card.querySelectorAll('input[name="max-quantity"]').forEach((input) => {
        input.value = maxQuantity ?? "";
      });

      featured_card.querySelectorAll('input[name="inventory-quantity"]').forEach((input) => {
        input.value = inventoryQuantity ?? "";
      });
    };

    const updateProductCardOutOfStockDisplay = (card, variant) => {
      const outOfStockContainer = card.querySelector(".back-in-stock-container");
      const productFormButtons = card.querySelector(".product-form__buttons");

      if (!variant || isLoyaltyLogin(card)) {
        return;
      }

      const customMetafields = variant.metafields?.custom;
      const variantOnlineValue = customMetafields?.variantOnline;
      const backInStockValue = customMetafields?.backInStock;
      const enableWaitlistValue =
        customMetafields?.effectiveWaitlist ?? customMetafields?.enableWaitlist;

      // Reset states initially to ensure proper visibility changes
      if (outOfStockContainer) outOfStockContainer.innerHTML = ""; // Clear existing messages
      if (outOfStockContainer) outOfStockContainer.style.display = "none";
      if (productFormButtons) productFormButtons.classList.remove("hide");

      if (variantOnlineValue === "false") {
        if (outOfStockContainer) {
          outOfStockContainer.innerHTML = `
            <button type="button" class="back-in-stock-btn" disabled>
              ${window.variantStrings.unavailable}
            </button>
          `;
          outOfStockContainer.style.display = "block";
        }
        if (productFormButtons) productFormButtons.classList.add("hide");
        return;
      }

      // Check if waitlist should be shown first (takes priority over out-of-stock)
      const isWaitlistEnabled = enableWaitlistValue === true || enableWaitlistValue === "true";
      const shouldShowWaitlist = isWaitlistEnabled && (variant.available || (!variant.available && backInStockValue === "true"));

      // If waitlist should be shown, don't show out-of-stock
      if (shouldShowWaitlist) {
        outOfStockContainer.innerHTML = "";
      }

      // New out-of-stock logic: 2 cases (only if not waitlist)
      // 1. Not available AND back_in_stock_disabled = true AND waitlist = false/empty (out of stock button)
      // 2. Not available AND back_in_stock_disabled = false/empty (back in stock form)
      const shouldShowOutOfStock = !variant.available && backInStockValue === "true" && !isWaitlistEnabled;
      const shouldShowBackInStock = !variant.available && backInStockValue !== "true";
      const productHandle =
        parsedProductData?.product?.handle || parsedProductData?.handle || card?.dataset?.handle || variant?.handle;

      if (shouldShowOutOfStock) {
        if (outOfStockContainer) {
          outOfStockContainer.innerHTML = `
            <button
              type="button"
              class="button button--full-width out-of-stock-btn">
              ${window.getStockStatusLabel?.(productHandle) || window.variantStrings?.soldOut}
            </button>
          `;
          outOfStockContainer.style.display = "block";
        }
        if (productFormButtons) productFormButtons.classList.add("hide");
      } else if (shouldShowBackInStock) {
        if (outOfStockContainer) {
          const root = window.Shopify?.routes?.root || "/";
          const productUrl = `${root}products/${productHandle || ""}`;
          outOfStockContainer.innerHTML = `
            <div class="back-in-stock-form">
              <a href="${productUrl}" class="button button button--full-width button--primary notify-me-btn">Notify Me</a>
            </div>
          `;
          outOfStockContainer.style.display = "block";
        }
        if (productFormButtons) productFormButtons.classList.add("hide");
      } else {
        if (productFormButtons) productFormButtons.classList.remove("hide");
        if (outOfStockContainer) outOfStockContainer.innerHTML = "";
        if (outOfStockContainer) outOfStockContainer.style.display = "none";
      }

      // If waitlist should be shown, make sure buy buttons are hidden
      if (shouldShowWaitlist) {
        productFormButtons.classList.add("hide");
        // Don't touch waitlist container - let updateProductCardWaitlistDisplay handle it
      }
    };

    const updateProductCardWaitlistDisplay = (card, variant) => {
      const productFormButtons = card.querySelector(".product-form__buttons");
      const waitlistContainer = card.querySelector(".waitlist-container");

      if (!variant || isLoyaltyLogin(card)) {
        return;
      }

      const customMetafields = variant.metafields?.custom;
      const enableWaitlistValue =
        customMetafields?.effectiveWaitlist ?? customMetafields?.enableWaitlist;
      const backInStockValue = customMetafields?.backInStock;

      // New waitlist logic: 2 cases
      // 1. Variant available AND waitlist = true
      // 2. Not available AND waitlist = true AND back_in_stock_disabled = true
      const isWaitlistEnabled = enableWaitlistValue === true || enableWaitlistValue === "true";
      const shouldShowWaitlist = isWaitlistEnabled && (variant.available || (!variant.available && backInStockValue === "true"));

      if (shouldShowWaitlist) {
        // Hide buy buttons when waitlist is enabled
        if (productFormButtons) {
          productFormButtons.classList.add("hide");
        }

        // Show waitlist form
        if (waitlistContainer) {
          waitlistContainer.style.display = "block";
        }
      } else {
        // Show buy buttons when waitlist is disabled
        if (productFormButtons) {
          productFormButtons.classList.remove("hide");
        }

        // Hide waitlist form
        if (waitlistContainer) {
          waitlistContainer.style.display = "none";
        }
      }
    };

    const UpdateProductPrice = (updated_price, updated_compare_at_price, updated_save_price) => {
      const price_elements = featured_card.querySelectorAll(".product-price");
      const compare_at_price = featured_card.querySelector(".product-compare-at-price");
      const save_price = featured_card.querySelector(".product-save-price");
      const price_sale = featured_card.querySelector(".price__sale");

      const price_regular = featured_card.querySelector(".price__regular");
      const price_container = featured_card.querySelector(".price-section-data");

      price_elements.forEach((price_element) => {
        price_element.innerHTML = updated_price;
      });

      if (updated_compare_at_price == updated_price || !updated_compare_at_price) {
        price_container.classList.remove("price--on-sale");
        price_sale.style.display = "none";
        price_regular.style.display = "flex";
      } else {
        price_container.classList.add("price--on-sale");
        compare_at_price.innerHTML = updated_compare_at_price;
        save_price.innerHTML = updated_save_price;
        price_regular.style.display = "none";
        price_sale.style.display = "flex";
      }
    };


   const UpdateSavePercentage = (variant) => {
      if (window.updateSavePercentageBadge) {
        window.updateSavePercentageBadge(featured_card, variant);
      }
    };

    const UpdateProductSwatches = () => {
      try {
        const product_card_swatches = featured_card.querySelector(".product-card-swatches");
        const quick_add = featured_card.querySelector(".quick-add");

        if (product_card_swatches) {
          const isFeaturedCarousel = product_card_swatches.className.includes("featured-carousel");
          const isSearch = product_card_swatches.className.includes("search-modal-swatches");
          const isNewDesignCard = featured_card.classList.contains("featured-card-product--new-design");
          const getOuterWidth = (element) => {
            if (!element) return 0;

            const rect = element.getBoundingClientRect();
            const styles = window.getComputedStyle(element);
            const marginLeft = parseFloat(styles.marginLeft || "0");
            const marginRight = parseFloat(styles.marginRight || "0");

            return rect.width + marginLeft + marginRight;
          };

          const getAvailableWidth = () => {
            const pickerWidth = featured_card
              .querySelector(".feature-card_options-picker")
              ?.getBoundingClientRect?.().width;
            const swatchesWidth = product_card_swatches.getBoundingClientRect().width;
            const infoWidth = featured_card
              .querySelector(".product__info-container")
              ?.getBoundingClientRect?.().width;
            const cardWidth = featured_card.getBoundingClientRect().width;

            return Math.floor(pickerWidth || swatchesWidth || infoWidth || cardWidth || 0);
          };

          let gapSpace = parseFloat(
            getComputedStyle(product_card_swatches).columnGap || getComputedStyle(product_card_swatches).gap || "0",
          );
          const boxes = [...(product_card_swatches?.children || [])];
          const swatchBoxes = boxes.filter((el) => !el.classList?.contains("quick-add"));
          const selectedSwatch = featured_card.querySelector(".selected-swatch");
          const selectedSwatchBox = selectedSwatch
            ? selectedSwatch.closest(".product-swatch-new-wrapper") || selectedSwatch
            : null;
          let selectedBox =
            selectedSwatchBox && selectedSwatchBox.parentElement === product_card_swatches
              ? selectedSwatchBox
              : swatchBoxes[0] || null;

          if (!selectedBox) {
            if (quick_add) quick_add.style.display = "none";
            return;
          }

          const filteredVariants =
            parsedProductData?.variants?.filter((variant) => variant?.metafields?.custom?.variantOnline !== "false") || [];

          let shouldShowQuickAdd = false;
          let visibleBoxes = [];

          if (isNewDesignCard) {
            const quickAddButton = quick_add?.querySelector(".featured-card_choose-more-colors");
            const availableWidth = getAvailableWidth();
            const swatchBoxWidth = getOuterWidth(selectedBox) || getOuterWidth(swatchBoxes[0]);
            const quickAddWidth = getOuterWidth(quickAddButton);
            const slotWidth = Math.max(swatchBoxWidth, quickAddWidth, 1);
            const totalVariantCount = filteredVariants.length || swatchBoxes.length;

            let maxBoxes = Math.floor((availableWidth + gapSpace) / (slotWidth + gapSpace));
            if (!Number.isFinite(maxBoxes) || maxBoxes < 1) {
              maxBoxes = 1;
            }

            maxBoxes = Math.min(maxBoxes, swatchBoxes.length + (quick_add ? 1 : 0));

            shouldShowQuickAdd = totalVariantCount > maxBoxes;
            const visibleSwatchCount = shouldShowQuickAdd
              ? Math.max(maxBoxes - 1, 1)
              : Math.min(totalVariantCount, maxBoxes);

            visibleBoxes = swatchBoxes.slice(0, visibleSwatchCount);
          } else {
            let card_width = Math.floor(parseFloat(getComputedStyle(featured_card).width));
            const refSwatch = swatchBoxes.find((b) => !b.classList.contains("selected-swatch") && !b.querySelector(".selected-swatch")) || swatchBoxes[0];
            const swatchWidth = refSwatch
              ? (refSwatch.classList.contains("product-swatch-new-wrapper")
                  ? (refSwatch.querySelector(".product-swatch")?.offsetWidth || refSwatch.clientWidth || 34)
                  : (refSwatch.clientWidth || refSwatch.offsetWidth || 34))
              : 34;
            let boxWidth = swatchWidth + gapSpace;

          if (!card_width) {
            if (isFeaturedCarousel) {
              card_width = 230;
            } else {
              card_width = window.innerWidth > 750 ? 315 : window.innerWidth < 390 ? 120 : 150;
            }
          }

          if (isSearch) {
            if (window.innerWidth > 750) {
              card_width = 315;
              boxWidth = 42;
              gapSpace = 5;
            } else {
              card_width = window.innerWidth / 2 - 54;
              boxWidth = 31;
              gapSpace = 3;
            }
          }

          if (isFeaturedCarousel) {
            if (window.innerWidth > 989) {
              card_width = 315;
              boxWidth = 40;
              gapSpace = 6;
            } else if (window.innerWidth > 750) {
              card_width = 230;
              boxWidth = 40;
              gapSpace = 6;
            } else {
              if (card_width && card_width < 200) {
                boxWidth = 33;
                gapSpace = 40;
              } else {
              card_width = 230;
              boxWidth = 33;
              gapSpace = 3;
            }
          }
          }
          const card_padding = 20;
          const containerWidth = card_width - card_padding + gapSpace;
          let maxBoxes = Math.floor(containerWidth / boxWidth);
         
          if (window.innerWidth <= 360) {
            maxBoxes = 3;
          } else if (window.innerWidth <= 750 && card_width && card_width < 200) {
            maxBoxes = 4;
          }  else if (maxBoxes > 8) {
            maxBoxes = 8;
          }
          visibleBoxes = swatchBoxes.slice(0, Math.max(maxBoxes - 1, 0));
            shouldShowQuickAdd = filteredVariants.length > visibleBoxes.length;
          }

          if (selectedBox && !visibleBoxes.includes(selectedBox)) {
            visibleBoxes = [...visibleBoxes.slice(0, -1), selectedBox];
          }

          swatchBoxes.forEach((box) => {
            box.style.display = visibleBoxes.includes(box) ? "block" : "none";
          });

          if (quick_add) {
            quick_add.style.display = shouldShowQuickAdd ? "block" : "none";
          }

          // Hide the quick view for the current product
          const url = new URL(window.location.href);
          const path = url.pathname;

          let handle = null;

          if (path.includes("/products/")) {
            handle = path.split("/products/")[1]?.split("/")[0];
          }

          if (handle === product_card_swatches?.dataset?.handle) {
            boxes?.forEach((box) => {
              if (box.className.includes("quick-add")) {
                box.style.display = "none";
              }
            });
          }
        }
      } catch (e) {
        console?.error?.("UpdateProductSwatches error:", e);
      } finally {
        const loading_spinner = featured_card.querySelector(".loading__spinner");
        if (loading_spinner) {
          loading_spinner.classList.add("hidden");
        }
      }
    };

    observeLazyImages();

    const syncSelectedSwatch = (variantId) => {
      const fallbackVariantId = default_selected_variant?.id;
      const resolvedVariantId = variantId || fallbackVariantId;

      swatches.forEach((swatch) => {
        swatch.classList.toggle("selected-swatch", String(swatch.dataset.id) === String(resolvedVariantId));
      });
    };

    const currentSelectedVariantId =
      featured_card.querySelector(".product-variant-id")?.value ||
      featured_card.querySelector(".selected-swatch")?.dataset?.id ||
      default_selected_variant?.id;

    syncSelectedSwatch(currentSelectedVariantId);

    swatches?.forEach((swatch) => {
      if (swatch.dataset.swatchBound === "true") {
        return;
      }

      swatch.dataset.swatchBound = "true";
      swatch.addEventListener("click", () => {
        const variant = parsedProductData.variants.find((item) => item.id == swatch.dataset.id);
        let image_url;
        let secondaryUpdatedImage;
        if (variant.metafields.custom.image_url) {
          image_url = variant.metafields.custom.image_url[0];
          secondaryUpdatedImage = variant.metafields.custom.image_url[1];
        }
        const short_description = variant.metafields.custom.shortDescription;
        const enable_waitlist = variant.metafields.custom.enableWaitlist;
        const isAvailable = variant.available;

        const selectedSwatchInputs = featured_card.querySelectorAll(".product-variant-id");
        if (selectedSwatchInputs.length) {
          selectedSwatchInputs.forEach((input) => {
            input.value = variant.id;
          });
        }

        syncSelectedSwatch(variant.id);

        // Call Functions
        if (
          featured_card.dataset.invertPlpHoverImages === "true" &&
          image_url &&
          secondaryUpdatedImage
        ) {
          const tmp = image_url;
          image_url = secondaryUpdatedImage;
          secondaryUpdatedImage = tmp;
        }
        UpdateProductImage(image_url, secondaryUpdatedImage);
        UpdateProductDescription(short_description);
        UpdateAddToBagStatus(isAvailable);
        UpdateProductPrice(variant.price, variant.compare_at_price, variant.save_price);
        UpdateSavePercentage(variant);
        updateProductCardWaitlistDisplay(featured_card, variant);
        updateProductCardOutOfStockDisplay(featured_card, variant);
        updateVariantQuantityLimits(variant);
      });
    });

    // Run function on load and on width-change only resize
    if (featured_card.dataset.swatchResizeBound !== "true") {
      let lastWidth = window.innerWidth;
      window.addEventListener("resize", () => {
        if (window.innerWidth !== lastWidth) {
          lastWidth = window.innerWidth;
          UpdateProductSwatches();
        }
      });
      featured_card.dataset.swatchResizeBound = "true";
    }

    UpdateProductSwatches();
  });
};
